
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const FlagIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6 3h14l-2 4.5 2 4.5H6"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width=".6" d="M7.5 20.25h-3"/><path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" d="M6 19.5V3"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
  </SvgIcon>
);
